'use strict';

/* globals $ */
import reviews from '../../services/reviews';

const $deleteActionButton = $('.js-delete-review-action');

$(document.body).on('click', '.js-btn-delete', function (event) {
  const $this = $(this);
  const url = $this.data('reviewUrl');
  const reviewType = $this.data('reviewType');
  $('.js-delete-review-modal')
    .find('.js-delete-review-action')
    .attr('data-review-url', url)
    .attr('data-review-type', reviewType);
});

$deleteActionButton.on('click', function () {
  const $this = $(this);

  $this.removeClass('error');
  $this.addClass('busy');

  const url = $this.data('reviewUrl');
  const reviewType = $this.data('reviewType');

  reviews.deleteReview(url, reviewType)
    .then(function () {
      window.location.href = window.location;
    })
    .catch(function () {
      $this.removeClass('busy');
      $this.addClass('error');
    });
});
